<h2>no access</h2>
<div>
  <div>no application is associated with the logged in user</div>
  please contact
  <a [href]="contactDetails()?.slackChannelLink" target="_blank">#common-applications</a>
  team to get access or to get your application added to dictionary service or
</div>
<div class="action-container">
  <button mat-flat-button data-ask-access-button (click)="onAskForAccessClick()">
    ask for access
  </button>
</div>
